import React from "react";
import { useState, useEffect } from "react";
import CsvExportModal from "../../../../../../components/generic/CsvExportModal";

/**
 * formats connection details table data for CSV export
 * @param {Array.<Object>} tableData raw table data from a connection details page
 * @param {Boolean} exportModalVisible show modal if true
 * @param {Function} handleCancelModal close modal callback
 * @returns
 */
const ExportConnectionsDetailsModal = (props) => {
  const [exportData, setExportData] = useState([]);
  const [institutionName, setInstitutionName] = useState("institution-name-not-found");

  useEffect(() => {
    if (!props.tableData || props.tableData.length < 1) {
      return;
    }
    const newExportData = props.tableData.map((account) => {
      return {
        institution_name: account.institution_name,
        account_name: account.description,
        account_number_last_4:
          account.account_number_last_4 &&
          account.account_number_last_4.length === 4
            ? account.account_number_last_4
            : account.account_number_last_4.slice(-4),
        is_assigned_to_dashboard: account.is_assigned ? "Yes" : "No",
        balance: account.last_current_balance,
        status: account.api_connection_status_live ? "Live" : "Not Live",
        source: account.source,
        entity: account.beneficiary_name,
      };
    });
    setInstitutionName(newExportData[0].institution_name);
    setExportData(newExportData);
  }, [props.tableData]);

  return (
    <CsvExportModal
      data={exportData}
      fileName={institutionName}
      downloadMessage={"Download account information for the ### account(s)."}
      modalVisible={props.exportModalVisible}
      handleCancelModal={props.handleCancelModal}
    />
  );
};

export default ExportConnectionsDetailsModal;
